/// <amd-module name="Build/Common/Library/Legacy/PivotItemToTabProvider" />
import { ObservableArray } from 'VSS/Core/Observable';
import { ContributedPivotBarItemProvider, GetContextType } from "VSS/Features/Frame/ContributedPivotBarItemProvider";
import { IVssPageContext } from 'VSS/Platform/Context';
import { IObservableViewStateUrl } from 'VSSUI/Navigation/ViewStateNavigation';
import { IVssHubViewState } from "VSSUI/Navigation/VssHubViewState";
import { IVssContributedPivotBarItem } from "VSSUI/PivotBar";
import { IVssContributedTab } from "VSSUI/Tabs";
import { MutatedItemProvider, ObservableArrayWrappingItemProvider } from "VSSUI/Utilities/ItemContribution";

export function getPivotItemToTabProvider(pageContext: IVssPageContext, contributionId: string, getContext: GetContextType, viewUrls: {[key: string]:IObservableViewStateUrl}, hubViewState: IVssHubViewState): ObservableArray<IVssContributedTab> {
    return new ObservableArrayWrappingItemProvider<IVssContributedTab>(
        new MutatedItemProvider<IVssContributedPivotBarItem, IVssContributedTab>(
            new ContributedPivotBarItemProvider({
                pageContext: pageContext,
                tabGroupIds: [contributionId],
                getContext: getContext
            }),
            (item: IVssContributedPivotBarItem) => {
                const pivot = getPivotBarItem(item, viewUrls, hubViewState);
                return {
                    id: pivot.itemKey || pivot.id,
                    name: pivot.text,
                    render: pivot.render,
                    order: pivot.order,
                    url: pivot.url,
                    onBeforeTabChange: pivot.onBeforePivotChange
                } as IVssContributedTab;
            }
        )
    ).getItems();
}

function getPivotBarItem(pivot: IVssContributedPivotBarItem, viewUrls: {[key: string]:IObservableViewStateUrl}, hubViewState: IVssHubViewState ): IVssContributedPivotBarItem {
    const id = pivot.id || pivot.itemKey || "";
    if (id && !pivot.url) {
        if (!viewUrls[id]) {
            viewUrls[id] = hubViewState.createObservableUrl({ view: id });
        }
        pivot.url = viewUrls[id];
        pivot.itemKey = id;
    }

    return pivot;
}
